<div class="form-group">
    <label [for]="id" >{{title}} {{control | controlRequiredText}}</label>

    <input-phone
    [id]="id"
    [title]="title" 
    [placeholder]="placeholder" 
    [control]="control"></input-phone>

    <div-validation-message 
    [control]="control" 
    [messageRequired]="messageRequired" 
    [messagePattern]="messagePattern" 
    ></div-validation-message>

</div>
